export default "__VITE_ASSET__d7b20eca__"